module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAG1BMVEUAAABUQz5UQj1bSUBVQz1UQj3s6un///+EeHQEv5+TAAAABXRSTlMA5qYc7dRG+h8AAABbSURBVEjHYxgFJAJmxVBUIGSAqcgkFB04YypSxVAUhKlIFENRIKai0FAMgVFFo4pGFY0qGlU0qmjQKEIDFCtqyyBCUXoZHkWicEV4qldVDOuCiK7yCTceRgQAAN9ZhovGH4+iAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download/download_icon_phone_selected.png
// module id = ykBM
// module chunks = 10